import { withLayout } from 'pages/Layout'

import UncompletedInfo from './UncompletedInfo'

export default withLayout('uncompleted', UncompletedInfo)
